var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "exam" },
    [
      _c("div", { staticClass: "nuv" }, [
        _c("span", [_vm._v("群培训管理 >")]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.groupName))])
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _c(
            "a",
            {
              staticClass: "top-button",
              attrs: {
                href:
                  "/tjkStudy/groupTrain?groupId=" +
                  _vm.groupId +
                  "&groupName=" +
                  _vm.groupName
              }
            },
            [
              _c("el-button", { attrs: { type: "primary", plain: "" } }, [
                _vm._v("群考核名单")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a",
            { staticClass: "top-button", attrs: { href: "javascript:;" } },
            [
              _c("el-button", { attrs: { type: "primary" } }, [
                _vm._v("群待岗学员")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("el-tooltip", { attrs: { placement: "right", effect: "light" } }, [
            _c(
              "div",
              {
                staticClass: "tip-con",
                attrs: { slot: "content" },
                slot: "content"
              },
              [
                _c("p", [
                  _vm._v("群待岗学员发起群考核时，默认全部学员发起考核")
                ])
              ]
            ),
            _vm._v(" "),
            _c("a", { staticClass: "tip-box" }, [_vm._v("？")])
          ])
        ],
        1
      ),
      _vm._v(" "),
      !!_vm.examiningList
        ? _c(
            "ul",
            { staticClass: "tab" },
            _vm._l(_vm.examiningList, function(t, key) {
              return _c("li", { staticClass: "active" }, [
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "/tjkStudy/waitWorkExam?id=" +
                        t.examineRecordId +
                        "&groupId=" +
                        _vm.groupId +
                        "&groupName=" +
                        _vm.groupName,
                      target: "_blank"
                    }
                  },
                  [_vm._v(_vm._s(t.codeName))]
                )
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.success
        ? _c("p", { staticClass: "tj-shift-notice" }, [
            _vm._v(_vm._s(_vm.message))
          ])
        : [
            !_vm.list.length
              ? _c("p", { staticClass: "tj-shift-notice" }, [
                  _vm._v("暂无记录！")
                ])
              : [
                  _c(
                    "el-table",
                    {
                      ref: "multipleTable",
                      staticStyle: { width: "100%" },
                      attrs: {
                        border: "",
                        data: _vm.list,
                        "tooltip-effect": "dark"
                      },
                      on: { "selection-change": _vm.handleSelectionChange }
                    },
                    [
                      _c("el-table-column", { attrs: { type: "selection" } }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "realName", label: "考核人员" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "tjkNumber", label: "淘金号" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "是否通过" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.passState == "Passed"
                                  ? [_vm._v("通过")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Failed"
                                  ? [_vm._v("未通过")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Abandoned"
                                  ? [_vm._v("标记不参培")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "Retrial"
                                  ? [_vm._v("建议复训")]
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.passState == "AbandonInTrain"
                                  ? [_vm._v("培训老师同意放弃")]
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "score", label: "综合得分" }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "remark", label: "备注" }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tj-margin-top-xl tj-margin-bottom-xl" },
                    [
                      _c("el-button", { on: { click: _vm.toggleSelection } }, [
                        _vm._v("移除待岗学员名单")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.checkGroup }
                        },
                        [_vm._v("群考核")]
                      )
                    ],
                    1
                  )
                ]
          ],
      _vm._v(" "),
      _c("Modal", { ref: "check" }, [
        _c("div", { staticClass: "tj-table tj-fill tj-padding-right-xl" }, [
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right" },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 外呼电话：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.callOutPhone,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "callOutPhone", $$v)
                    },
                    expression: "check.callOutPhone"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 平均外呼时长（分钟）：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.avgDuration,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "avgDuration", $$v)
                    },
                    expression: "check.avgDuration"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("dl", [
            _c(
              "dt",
              { staticClass: "tj-text-right", staticStyle: { width: "200px" } },
              [
                _c("font", { attrs: { color: "red" } }, [_vm._v("*")]),
                _vm._v(" 考核代号：")
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "dd",
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入内容", clearable: "" },
                  model: {
                    value: _vm.check.codeName,
                    callback: function($$v) {
                      _vm.$set(_vm.check, "codeName", $$v)
                    },
                    expression: "check.codeName"
                  }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f869bd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f869bd6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/college/waitWork.vue
// module id = 1166
// module chunks = 0